<button
  id="likeButton"
  class="button summary-button like-button"
  type="button"
  rdxAnalytics="Like Item"
  [rdxAnalyticsData]="communityItem.linkedType"
  (click)="isLiked ? unLike() : like()"
>
  <svg-icon
    src="/assets/icons/likes.svg"
    alt="like"
    [class]="iconColor"
    [svgClass]="isLiked ? 'likes-filled' : ''"
    i18n-alt
  />

  <div class="like-count">
    @if (!iconOnly) {
      <div class="count-container">
        <span i18n>Like{{ likeCount > 0 ? ' (' + likeCount + ')' : '' }}</span>
      </div>
    } @else {
      @if (likeCount > 0) {
        <div class="count-container">
          <span i18n>({{ likeCount }})</span>
        </div>
      }
    }
  </div>
</button>
